
import { StepConnector, stepConnectorClasses } from '@mui/material';
import { styled } from '@mui/system';

const Connector = styled(StepConnector)(() => ({
  [`& .${stepConnectorClasses.lineVertical}`]: {
    marginLeft: '10px',
    display: 'none'
  },
  [`& .${stepConnectorClasses.vertical}`]: {
    marginLeft: '10px',
  },
}));
  
export default Connector;